import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import Home from '../containers/TruckKanban/Home/TruckKanban';
import Parameters from '../containers/TruckKanban/Home/Parameters';
import SpaceXd from '../containers/TruckKanban/Space/SpaceXD';
import FastSpaceXD from '../containers/TruckKanban/Space/FastSpaceXD';
import CreateMvi from '../containers/TruckKanban/Space/Mvi/CreateMvi';
import MviList from '../containers/TruckKanban/Space/Mvi/MviList/MviList';
import TransmissionLog from '../containers/TruckKanban/TransmissionLog/TransmissionLog';
import TransmissionDetail from '../containers/TruckKanban/TransmissionLog/TransmissionDetail';
import HomeHighCostMaterial from '../containers/TruckKanban/HighCostMaterial/Home';
import HomeHighCostMaterialInsert from '../containers/TruckKanban/HighCostMaterial/Insert';
import HomeHighCostMaterialList from '../containers/TruckKanban/HighCostMaterial/List';
import PrintLabelList from '../containers/PhysicalConfirmationV2/Print/PrintLabelList';
import Registrations from '../containers/TruckKanban/Registrations/Home';
import ShedArea from '../containers/TruckKanban/Registrations/ShedArea/ShedArea';
import ShedAreaInsert from '../containers/TruckKanban/Registrations/ShedArea/ShedAreaInsert';
import ShedAreaList from '../containers/TruckKanban/Registrations/ShedArea/ShedAreaList';

let aux = 0;
const pathurl = getPathApp(window);
const TruckKanbanRoute = [

    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/highcostmaterial/List`} component={HomeHighCostMaterialList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/highcostmaterial/Insert`} component={HomeHighCostMaterialInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/highcostmaterial/home`} component={HomeHighCostMaterial} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/parameters`} component={Parameters} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/home`} component={Home} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/createMvi`} component={CreateMvi} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/spacexd`} component={SpaceXd} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/fastspacexd`} component={FastSpaceXD} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/mviList`} component={MviList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/printlabel`} component={PrintLabelList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/transmissionLog/details`} component={TransmissionDetail} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/transmissionLog`} component={TransmissionLog} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/registrations/home`} component={ShedArea} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/registrations/List`} component={ShedAreaList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/registrations/Insert`} component={ShedAreaInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/truckkanban/registrations`} component={Registrations} />
];

export default TruckKanbanRoute;
